import classNames from "classnames";
import { SearchIcon } from "~/common/icons/SearchIcon";

export function SearchResultsLink({ searchTerm }: { searchTerm: string }) {
  return (
    <a
      href={`/search?q=${searchTerm}`}
      className={classNames(
        "autocomplete-custom-search",
        "tw:!flex tw:!items-center tw:!px-3 tw:!py-1 tw:!ml-6 tw:!space-x-3",
        "tw:!ring-1 tw:!ring-offset-2 tw:!ring-transparent",
        "tw:!transition-colors tw:!no-underline tw:!text-blue-500 tw:hover:!text-blue-600 tw:!rounded-lg",
      )}
    >
      <SearchIcon className="tw:!fill-blue-500 hover:tw:!fill-blue-600 tw:!h-4 tw:!w-4" />
      <span className="tw:!font-semibold tw:!text-[1.125rem]">
        Custom Search
      </span>
    </a>
  );
}
